import './Unauthorized.less';
import React, { Component } from 'react';
import {
  Alert,
  AppLocaleProvider,
  Button,
  Icon,
  Layout,
  Modal
} from 'sd-ui-components';
import mainLogo from '../../assets/smartdrive_logo.svg';
import { inject, observer } from 'mobx-react';
import UnauthenticatedFooter from '../AppLayout/UnauthenticatedFooter';

const { Header, Content } = Layout;
const { FormattedMessage } = AppLocaleProvider;

@inject('AuthStore')
@inject('ConfigStore')
@observer
class Unauthorized extends Component {
  state = {
    isSso: false,
    helpModalVisible: false
  };

  toggleModal = () => {
    this.setState({
      helpModalVisible: !this.state.helpModalVisible
    });
  };

  componentDidMount() {
    if (this.props.isSsoUser) {
      this.setState({ isSso: true });
    }
  }

  render() {
    return (
      <div className="unauthorized-root">
        <Layout className="unauthorized-layout">
          <Header className="unauthorized-header sd-branding-color-border sd-primary-background-color-2-fade">
            <img
              className="unauthorized-logo"
              src={mainLogo}
              alt="Smartdrive"
            />
          </Header>
          <Content className="unauthorized-content sd-primary-background-color-1-fade">
            <div>
              <h1>
                <FormattedMessage
                  id="App.Unauthorized.HeaderText"
                  defaultMessage="Unable to log in to Driver app"
                />
                {!this.props.ConfigStore.config[
                  this.props.ConfigStore.configurationKeys.betaMode
                ] && (
                  <Icon
                    icon="question-circle-o"
                    size={20}
                    className="unauthorized-help-icon"
                    onClick={this.toggleModal}
                  />
                )}
              </h1>
              <Modal
                title={
                  <h3>
                    <FormattedMessage
                      id="App.Help.Title"
                      defaultMessage="Need help?"
                    />
                  </h3>
                }
                visible={this.state.helpModalVisible}
                footer={[
                  <Button
                    className="unauthorized-help-modal-close-button"
                    onClick={this.toggleModal}
                  >
                    <FormattedMessage
                      id="App.Navigation.Close"
                      defaultMessage="Close"
                    />
                  </Button>
                ]}
                wrapClassName="unauthorized-help-modal"
                closable={false}
              >
                <p>
                  <FormattedMessage
                    id="App.Help.GlobalTechnicalSupport"
                    defaultMessage="Global technical support"
                  />
                  <br />
                  <a href="mailto:customer.service@smartdrive.net">
                    customer.service@smartdrive.net
                  </a>
                </p>
              </Modal>
            </div>
            <div>
              <Alert
                className="unauthorized-notifications"
                type="error"
                message={
                  <FormattedMessage
                    id="App.Unauthorized.AlertMessage"
                    defaultMessage="You do not have sufficient permission to access the Driver app. Please contact your system administrator for access."
                  />
                }
                description={<span />}
                showIcon={true}
              />
            </div>
            <div className="unauthorized-fleetlogin">
              {!this.state.isSso &&
                !this.props.AuthStore.loginInfo['appLauncher'] &&
                this.props.ConfigStore.config.fleetLoginUrl && (
                  <a href={this.props.ConfigStore.config.fleetLoginUrl}>
                    <FormattedMessage
                      id="App.Unauthorized.TakeMeToFleetLogin"
                      defaultMessage="Try logging into Response Center instead"
                    />{' '}
                    <Icon icon="arrow-right" size={12} />{' '}
                  </a>
                )}
            </div>
          </Content>
          <UnauthenticatedFooter />
        </Layout>
      </div>
    );
  }
}

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/containers/Unauthorized/Unauthorized.jsx